// В этом файле перечисляются константы, через которые можно
// инжектировать глобальные сторы в компонент через ProstoreContext

export const STORE_LOCATION = 'STORE_LOCATION';
export const STORE_AUTH = 'STORE_AUTH';
export const STORE_TARGET = 'STORE_TARGET';
export const STORE_PROD_CALENDAR = 'STORE_PROD_CALENDAR';
export const STORE_ABSENCE_TYPES = 'STORE_ABSENCE_TYPES';
